"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNASSIGNED_BROKER = void 0;
exports.UNASSIGNED_BROKER = 'unassigned';
//# sourceMappingURL=unassigned-broker.js.map